import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { withRouter } from 'react-router';
import Slug from '../../../components/slug/slug';
import AllFeed from '../../../components/all_feed/all_feed';

/*
import isEmpty from 'lodash/isEmpty';
import extend from 'lodash/extend';
import Ad from '../../../components/ad/ad';
*/

import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';

// eslint-disable-next-line
class CompanyPage extends Component {
  render() {
    if (this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.companyPage.isLoading) {
      return (
        <section className="company-page">
          <article className="company-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    /*

    const {
      companyData,
      companyNextData
    } = this.props;

    const adData = get(this.props, 'companyPage.ads');
    const combinedAdModel = extend({},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const pgTitle = 'company index';
    const section = get(this.props, 'match.params.section');
    const page = Number(get(this.props, 'match.params.page'));
    const nextPage = page && !isEmpty(companyNextData) ? String(page + 1) : null;
    const prevPage = page > 1 ? String(page - 1) : null;

*/
    return (
      <section className={`tag-page`}>
        <section className="page-title">
          <Slug
            slugName={`${get(this.props, 'company.name')}`}
            className="category-page"
          />
        </section>
        <section>
          <p
            dangerouslySetInnerHTML={{
              __html: get(this.props, 'company.bio') || ''
            }}
          />
        </section>
        <section>
          <AllFeed
            adModel={{}}
            stories={get(this.props, 'tagAllFeed.posts')}
            allRendered={get(this.props, 'tagAllFeed.allRendered')}
            updateAction={() => {}}
            currentSite={get(this.props, 'config.site')}
            env={get(this.props, 'config.env')}
          />
        </section>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    company: get(state, 'company.data.rows[0]', {}),
    companyData: get(state, 'companyData.data.rows[0]', {}),
    companyAwards: get(state, 'companyAwards.data.rows[0]', {}),
    companyPage: get(state, 'companyPage', {}),
    tagAllFeed: {
      allRendered: get(state, 'tagAllFeed.allRendered', false),
      posts: get(state, 'tagAllFeed.data', [])
    }
  };
}

CompanyPage.propTypes = {
  /* eslint-disable */
  status: PropTypes.number,
  config: PropTypes.shape(),
  company: PropTypes.shape({

  }),
  companyAwards: PropTypes.shape({

  }),
  companyData: PropTypes.shape({

  }),
  companyPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  tagAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool
  }).isRequired
  /* eslint-enable */
};

CompanyPage.defaultProps = {
  /* eslint-disable */
  status: PropTypes.number,
  companyData: PropTypes.shape({

  }),
  companyAwards: PropTypes.shape({

  }),
  companyPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  tagAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool
  }).isRequired
  /* eslint-enable */
};

export default withRouter(connect(mapStateToProps)(CompanyPage));



// WEBPACK FOOTER //
// ./src/views/containers/pages/company_page/company_page.js